import { useAppLayoutStateStore } from '../stores/app-layout-state';
import { useAppConfigStore } from '../stores/app-config-store';
import { storeToRefs } from 'pinia';
import { useAppMenuItemsStore } from '../stores/app-menu-items';
import { type MaybeRefOrGetter, toValue } from 'vue';
import { useColorScheme } from '@precon-tools-suite-by-shared/vue-color-schemes';

export function useLayout() {
    const stateStore = useAppLayoutStateStore();
    const configStore = useAppConfigStore();
    const menuItemsStore = useAppMenuItemsStore();

    const {
        staticMenuDesktopInactive,
        overlayMenuActive,
        configSidebarVisible,
        staticMenuMobileActive,
        menuHoverActive,
        rightMenuActive,
        topbarMenuActive,
        sidebarActive,
        overlaySubmenuActive,
        isDesktop,
        isSidebarActive,
    } = storeToRefs(stateStore);

    const {
        rtl: RTL,
        ripple,
        inputStyle,
        menuMode,
        scale,
        menuTheme,
        topbarTheme,
        sidebarAnchored: anchored,
        slimMode: isSlim,
        slimPlusMode: isSlimPlus,
        horizontalMode: isHorizontal,
        overlayMode: isOverlay,
        staticMode: isStatic,
    } = storeToRefs(configStore);

    const { activeItem: activeMenuItem } = storeToRefs(menuItemsStore);

    const { modelValue: colorScheme } = useColorScheme();

    function setScale(newValue: number) {
        configStore.setScale(newValue);
    }

    function showConfigSidebar() {
        stateStore.showConfigSidebar();
    }

    function showSidebar() {
        stateStore.showSidebar();
    }

    function setActiveMenuItem(item: MaybeRefOrGetter) {
        activeMenuItem.value = toValue(item);
    }

    function onMenuToggle() {
        stateStore.toggleMenu();
    }

    function onConfigSidebarToggle() {
        stateStore.toggleConfigSidebar();
    }

    return {
        layoutConfig: {
            RTL,
            ripple,
            inputStyle,
            menuMode,
            colorScheme,
            scale,
            menuTheme,
            topbarTheme,
        },
        layoutState: {
            staticMenuDesktopInactive,
            overlayMenuActive,
            configSidebarVisible,
            staticMenuMobileActive,
            menuHoverActive,
            rightMenuActive,
            topbarMenuActive,
            sidebarActive,
            anchored,
            activeMenuItem,
            overlaySubmenuActive,
        },
        setScale,
        onMenuToggle,
        isSidebarActive,
        setActiveMenuItem,
        onConfigSidebarToggle,
        isSlim,
        isSlimPlus,
        isHorizontal,
        isDesktop,
        isOverlay,
        isStatic,
        showConfigSidebar,
        showSidebar,
    };
}
